/* eslint-disable import/prefer-default-export */
import { useState, useEffect } from 'react';

export const useGetSearch = (string = '') => {
  const [search, setSearch] = useState({});

  useEffect(() => {
    const obj = {};

    new URLSearchParams(string).forEach((value, key) => {
      obj[key] = value;
    });

    setSearch(obj);
  }, [string]);

  return search;
};
